var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ig-integrations" } },
    [
      _c(
        "AppBreadCrumb",
        { attrs: { paths: [{ title: "Instagram" }], select: true } },
        [
          _vm.initialized && _vm.status.purchased
            ? _c(
                "a-button",
                {
                  staticClass: "actionButtonBreadcrumb",
                  attrs: { type: "danger" },
                  on: { click: _vm.unsubscribe },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("wp.unsubscribe")) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex",
          staticStyle: { "background-color": "#ffffff" },
        },
        [
          _c(
            "div",
            { staticClass: "side-menubar-wrapper" },
            [
              _c("InstagramMenu", {
                attrs: { "selected-page": "integration" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main-content" },
            [
              _c(
                "a-spin",
                { attrs: { tip: "Loading...", spinning: !_vm.initialized } },
                [
                  _c(
                    "div",
                    { staticClass: "spin-content" },
                    [
                      _vm.showWizard
                        ? _c("InstagramWizard")
                        : _c(
                            "b-card",
                            [
                              _c(
                                "b-card-body",
                                {
                                  staticClass:
                                    "h-100 d-flex flex-column justify-content-center align-items-center my-0",
                                  staticStyle: { "min-height": "22vh" },
                                },
                                [
                                  _c("a-icon", {
                                    staticClass:
                                      "wp-icon-wp-integration mb-2 mr-1 ml-1",
                                    staticStyle: {
                                      color: "#e200a7 !important",
                                      "font-size": "60px !important",
                                    },
                                    attrs: { type: "instagram" },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "h4",
                                    { staticStyle: { "margin-top": "5px" } },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "1px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("instagramTitle"))
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        icon: "unlock",
                                        size: "large",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.showWizard = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t("instegramFunctionActive")
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-card-body",
                                {
                                  staticClass:
                                    "h-100 d-flex flex-column justify-content-center align-items-center my-2",
                                  staticStyle: { "min-height": "22vh" },
                                },
                                [
                                  [
                                    _c(
                                      "a-carousel",
                                      {
                                        staticStyle: {
                                          height: "500px !important",
                                          width: "960px !important",
                                        },
                                        attrs: {
                                          arrows: "",
                                          "dots-class":
                                            "slick-dots slick-thumb",
                                          autoplay: true,
                                          dotPosition: "bottom",
                                        },
                                      },
                                      _vm._l(
                                        _vm.baseUrl.length,
                                        function (item) {
                                          return _c("div", [
                                            _c("img", {
                                              attrs: {
                                                src: _vm.baseUrl[item - 1],
                                              },
                                            }),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ],
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }